define([
	'internal_util/Logger',
	'internal_util/Util',
	'amdi18n-loader?!service/nls/EventListenerRegistry_strings'
], function (
	Logger,
	Util,
	Strings
) {
	'use strict';

	var _listeners = {
		CORE_INITIALIZATION_STARTED : new Array(),
		CORE_INITIALIZATION_SUCCEEDED : new Array(),
		CORE_INITIALIZATION_FAILED : new Array(),

		CORE_STARTED : new Array(),
		CORE_SUCCEEDED : new Array(),
		CORE_FAILED : new Array(),

		CONTEXT_CHANGE_STARTED : new Array(),
		CONTEXT_CHANGE_SUCCEEDED : new Array(),
		CONTEXT_CHANGE_FAILED : new Array(),

		ABORT : new Array(),

		GET_ATTRIBUTE_DEFINITIONS_STARTED : new Array(),
		GET_ATTRIBUTE_DEFINITIONS_SUCCEEDED : new Array(),
		GET_ATTRIBUTE_DEFINITIONS_FAILED : new Array(),

		OPEN_ECARD_SUPPORTED_CARDS_PROTOCOLS_STARTED : new Array(),
		OPEN_ECARD_SUPPORTED_CARDS_PROTOCOLS_SUCCEEDED : new Array(),
		OPEN_ECARD_SUPPORTED_CARDS_PROTOCOLS_FAILED : new Array(),

		GET_OPTIONS_STARTED : new Array(),
		GET_OPTIONS_SUCCEEDED : new Array(),
		GET_OPTIONS_FAILED : new Array(),

		SELECT_OPTION_STARTED : new Array(),
		SELECT_OPTION_SUCCEEDED : new Array(),
		SELECT_OPTION_FAILED : new Array(),

		CANCEL_SELECT_OPTION_STARTED : new Array(),
		CANCEL_SELECT_OPTION_SUCCEEDED : new Array(),
		CANCEL_SELECT_OPTION_FAILED : new Array(),

		EID_CLIENT_DETECTION_STARTED : new Array(),
		EID_CLIENT_DETECTED : new Array(),
		EID_CLIENT_NOT_DETECTED : new Array(),
		EID_CLIENT_DETECTION_CYCLE_FINISHED : new Array(),
		EID_CLIENT_DETECTION_STOPPED : new Array(),

		TERMINAL_ADDED : new Array(),
		TERMINAL_REMOVED : new Array(),

		CARD_INSERTED : new Array(),
		CARD_RECOGNIZED : new Array(),
		CARD_REMOVED : new Array(),

		ACTIVATION_STARTED : new Array(),
		ACTIVATION_SUCCEEDED : new Array(),
		ACTIVATION_FAILED : new Array(),

		RECOVERY_STRATEGY_STARTED : new Array(),
		RECOVERY_STRATEGY_SUCCEEDED : new Array(),
		RECOVERY_STRATEGY_FAILED : new Array(),
		RECOVERY_STRATEGY_STOPPED : new Array(),

		GET_CLOUD_IDENTITY_OPTIONS_STARTED : new Array(),
		GET_CLOUD_IDENTITY_OPTIONS_SUCCEEDED : new Array(),
		GET_CLOUD_IDENTITY_OPTIONS_FAILED : new Array(),

		GET_CLOUD_IDENTITY_SESSION_STARTED : new Array(),
		GET_CLOUD_IDENTITY_SESSION_SUCCEEDED : new Array(),
		GET_CLOUD_IDENTITY_SESSION_FAILED : new Array(),

		GET_CLOUD_IDENTITY_ATTRIBUTES_STARTED : new Array(),
		GET_CLOUD_IDENTITY_ATTRIBUTES_SUCCEEDED : new Array(),
		GET_CLOUD_IDENTITY_ATTRIBUTES_FAILED : new Array(),

		CLOUD_IDENTITY_REQUEST_STARTED : new Array(),
		CLOUD_IDENTITY_REQUEST_SUCCEEDED : new Array(),
		CLOUD_IDENTITY_REQUEST_FAILED : new Array(),

		GET_CLOUD_IDENTITY_STARTED : new Array(),
		GET_CLOUD_IDENTITY_SUCCEEDED : new Array(),
		GET_CLOUD_IDENTITY_FAILED : new Array(),

		REVOKE_CLOUD_IDENTITIES_STARTED : new Array(),
		REVOKE_CLOUD_IDENTITIES_SUCCEEDED : new Array(),
		REVOKE_CLOUD_IDENTITIES_FAILED : new Array(),

		ACTIVATE_CLOUD_IDENTITY_STARTED : new Array(),
		ACTIVATE_CLOUD_IDENTITY_SUCCEEDED : new Array(),
		ACTIVATE_CLOUD_IDENTITY_FAILED : new Array(),

		UI_STATE_CHANGE_STARTED : new Array(),
		UI_STATE_CHANGE_FINISHED : new Array(),

		UI_STATE_INTERCEPTION_STARTED : new Array(),
		UI_STATE_INTERCEPTION_FINISHED : new Array(),

		WEBFONTS_LOADING_STARTED : new Array(),
		WEBFONTS_LOADING_SUCCEEDED : new Array(),
		WEBFONTS_LOADING_FAILED : new Array(),

		IMAGES_LOADING_STARTED : new Array(),
		IMAGES_LOADING_SUCCEEDED : new Array(),
		IMAGES_LOADING_FAILED : new Array()
	};


	// private methods

	function log(method, message, data) {
		Logger.log('EventListenerRegistry', method, message, data);
	}


	// public methods

	function addListener(event, listener) {
		var i;

		if (Util.isArray(event)) {
			for (i = 0; i < event.length; i++) {
				if (_listeners.hasOwnProperty(event[i])) {
					_listeners[event[i]].push({ listener : listener, fireOnce: false });
				}
			}
		} else if (_listeners.hasOwnProperty(event)) {
			_listeners[event].push({ listener : listener, fireOnce: false });
		} else {
			log('addListener', Strings.unknown_event, event);
		}
	}

	function addOneTimeListener(event, listener) {
		var i;

		if (Util.isArray(event)) {
			for (i = 0; i < event.length; i++) {
				if (_listeners.hasOwnProperty(event[i])) {
					_listeners[event[i]].push({ listener : listener, fireOnce: true });
				}
			}
		} else if (_listeners.hasOwnProperty(event)) {
			_listeners[event].push({ listener : listener, fireOnce: true });
		} else {
			log('addListener', Strings.unknown_event, event);
		}
	}

	function removeListener(event, listener) {
		var i, j;

		if (Util.isArray(event)) {
			for (i = 0; i < event.length; i++) {
				if (_listeners.hasOwnProperty(event[i])) {
					for (j = 0; j < _listeners[event[i]].length; j++) {
						if (_listeners[event[i]][j]['listener'] === listener) {
							_listeners[event[i]].splice(j, 1);
							j--;
						}
					}
				}
			}
		} else if (_listeners.hasOwnProperty(event)) {
			for (i = 0; i < _listeners[event].length; i++) {
				if (_listeners[event][i]['listener'] === listener) {
					_listeners[event].splice(i, 1);
					i--;
				}
			}
		} else {
			log('removeListener', Strings.unknown_event, event);
		}
	}

	function callListeners(event, data, doneCallback) {
		var listeners = new Array(),
			i;

		if (_listeners.hasOwnProperty(event)) {
			for (i = 0; i < _listeners[event].length; i++) {
				listeners.push(_listeners[event][i]['listener']);

				if (_listeners[event][i]['fireOnce']) {
					_listeners[event].splice(i, 1);
					i--;
				}
			}

			Util.callCallbacks(listeners, data, doneCallback);
		} else {
			log('callListeners', Strings.unknown_event, event);
			Util.callCallbacks(doneCallback);
		}
	}


	return {
		addListener : addListener,
		addOneTimeListener : addOneTimeListener,
		removeListener : removeListener,
		callListeners : callListeners
	};
});


//////////////////
// WEBPACK FOOTER
// ./src/main/web/js/app/service/EventListenerRegistry.js
// module id = 6
// module chunks = 4